// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState, useMemo } from 'react';
import { MDBInput } from 'mdbreact';
import Select from '../../layout/CustomSelect';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';

const SelectMessageRecipients = ({
  companyMembers,
  workOrder,
  getRecipients,
  selectedAllApplicants,
  setSelectedAllApplicants,
  applicants = [],
  activeTab,
  routedApplicants = [],
}) => {
  const [selectedCompanyUsers, setSelectedCompanyUsers] = useState([]);
  const [isNeedSendToContractor, setIsNeedSendToContractor] = useState(false);
  const [allApplicants, setApplicants] = useState([]);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [workOrderControlByStatus, setWorkOrderControlByStatus] = useState({});

  useEffect(() => {
    if (workOrder?.status) {
      setWorkOrderControlByStatus(workOrderStatusControl(workOrder.status));
    }
  }, [workOrder]);

  useEffect(() => {
    if (!workOrderControlByStatus.beforeAssigned) {
      const objOfContractor = {};
      routedApplicants.data && routedApplicants.data.forEach(item => {
        objOfContractor[item.contractor_id] = item.contractor_name;
      });
      applicants.contractor && applicants.contractor.forEach(item => {
        objOfContractor[item.contractor_details.userId] = item.contractor_details.name;
      });
      setApplicants(Object.keys(objOfContractor).map(value => ({
        value, label: objOfContractor[value],
      })));
    }
  }, [applicants, routedApplicants]);

  const sendRecipients = () => {
    const arrOfSelectedApplicantsId = selectedAllApplicants
      ? allApplicants.map(el => el.value)
      : selectedApplicants.map(el => el.value);
    getRecipients(
      [
        ...selectedCompanyUsers.map(el => el.value),
        ...arrOfSelectedApplicantsId,
      ],
      isNeedSendToContractor,
    );
  };

  const handlerOnChange = ({ value, name }) => {
    switch (name) {
      case 'selectedCompanyUsers': setSelectedCompanyUsers(value || []); break;
      case 'isNeedSendToContractor': setIsNeedSendToContractor(value); break;
      case 'selectedApplicants': setSelectedApplicants(value || []); break;
      default: break;
    }
  };

  useEffect(() => {
    sendRecipients();
  }, [selectedCompanyUsers, isNeedSendToContractor, selectedApplicants, selectedAllApplicants]);

  const tabName = useMemo(() => {
    return activeTab === 'assigned' || activeTab === 'completed' ? 'Assigned' : 'Applied/Routed'
}, [activeTab])

  return (
    <>
      
      {!workOrderControlByStatus.beforeAssigned && (
        <div className="field_row">
          <div className="field_block">
            <label className="check_btn">
              <input
                type="checkbox"
                name="isNeedSendToContractor"
                id="isNeedSendToContractor"
                value={isNeedSendToContractor}
                checked={isNeedSendToContractor}
                onChange={() => handlerOnChange({
                  name: 'isNeedSendToContractor',
                  value: !isNeedSendToContractor,
                })}
              />
              <div className="block_label">{`${tabName} Contractor's`}</div>
            </label>

          </div>
        </div>
      )}
      {workOrderControlByStatus.beforeAssigned && allApplicants.length > 0 && (
        <>
        <div className="field_row">

        <div className="radio_fields">
          
          <label className="check_btn">
            <input
              type="radio"
              name='recipientsMode'
              value="allApplicants"
              checked={selectedAllApplicants}
              onChange={() => setSelectedAllApplicants(true)}
            />
            All Applicants
          </label>
          <br />
          <label className="check_btn">
            <input
              type="radio"
              name='recipientsMode'
              value="applicants"
              checked={!selectedAllApplicants}
              onChange={() => setSelectedAllApplicants(false)}
            />
            Single Contractor(s)
          </label>
        </div>
        </div>
          <div className="field_row">
            <div className="field_block">
            <Select
              isDisabled={selectedAllApplicants}
              isClearable
              isSearchable
              isMulti
              closeMenuOnSelect={false}
              options={allApplicants}
              value={selectedApplicants}
              onChange={value => handlerOnChange({ name: 'selectedApplicants', value })}
            />
          </div>
          </div>
        </>
      )}
      <div className="field_row">
        <div className="field_name">
          <label htmlFor="workorder_company_users">Company User(s)</label>
        </div>
        <Select
          inputId="workorder_company_users"
          isClearable
          isSearchable
          isMulti
          closeMenuOnSelect={false}
          options={companyMembers}
          value={selectedCompanyUsers}
          onChange={value => handlerOnChange({ name: 'selectedCompanyUsers', value })}
        />
      </div>
    </>
  );
};

export default SelectMessageRecipients;
